
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ImpersonationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  user_id: 'user_id',
  impersonator_user_id: 'impersonator_user_id'
};

exports.Prisma.AuditLogScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  user_roles: 'user_roles',
  action: 'action',
  payload: 'payload',
  success: 'success',
  resource_id: 'resource_id',
  duration: 'duration',
  error: 'error',
  created_at: 'created_at'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  updated_at: 'updated_at',
  created_at: 'created_at',
  title: 'title',
  phone: 'phone',
  company_name: 'company_name',
  sign_up_intent: 'sign_up_intent',
  stripe_customer_id: 'stripe_customer_id',
  last_accessed_at: 'last_accessed_at',
  avatar_id: 'avatar_id',
  skip_intelligence_review_zipline_ready_to_approve_modal: 'skip_intelligence_review_zipline_ready_to_approve_modal',
  oauth_id: 'oauth_id',
  failed_login_attempts: 'failed_login_attempts',
  locked: 'locked'
};

exports.Prisma.UserCredentialScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  password_hash: 'password_hash',
  password_salt: 'password_salt',
  updated_at: 'updated_at',
  created_at: 'created_at'
};

exports.Prisma.UserRoleScalarFieldEnum = {
  id: 'id',
  role: 'role',
  type: 'type',
  created_at: 'created_at',
  resource_id: 'resource_id',
  user_id: 'user_id'
};

exports.Prisma.UserInvitationEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  user_invitation_id: 'user_invitation_id',
  event_type: 'event_type',
  event_data: 'event_data',
  event_by_id: 'event_by_id'
};

exports.Prisma.UserInvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  role: 'role',
  created_at: 'created_at',
  updated_at: 'updated_at',
  accepted_at: 'accepted_at',
  accepted_by_id: 'accepted_by_id'
};

exports.Prisma.ForgotPasswordTokenScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  used_at: 'used_at',
  user_id: 'user_id'
};

exports.Prisma.EmailVerificationTokenScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  verified_at: 'verified_at',
  user_id: 'user_id',
  email: 'email',
  last_email_sent_by_id: 'last_email_sent_by_id',
  last_email_sent_at: 'last_email_sent_at'
};

exports.Prisma.OAuthClientScalarFieldEnum = {
  client_id: 'client_id',
  client_secret: 'client_secret',
  redirect_uri: 'redirect_uri',
  created_at: 'created_at',
  updated_at: 'updated_at',
  disabled_at: 'disabled_at',
  name: 'name'
};

exports.Prisma.OAuthCodeScalarFieldEnum = {
  code: 'code',
  user_id: 'user_id',
  redirect_uri: 'redirect_uri',
  client_id: 'client_id',
  created_at: 'created_at',
  expires_at: 'expires_at',
  used_at: 'used_at'
};

exports.Prisma.OAuthTokenScalarFieldEnum = {
  token: 'token',
  code: 'code',
  created_at: 'created_at',
  expires_at: 'expires_at'
};

exports.Prisma.VendorScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  slug: 'slug',
  founded_year: 'founded_year',
  hq_location: 'hq_location',
  linkedin_profile_url: 'linkedin_profile_url',
  number_employees: 'number_employees',
  website: 'website',
  approved_at: 'approved_at',
  approved_by_id: 'approved_by_id',
  logo_file_id: 'logo_file_id',
  product_category_default_id: 'product_category_default_id',
  state: 'state',
  company_status: 'company_status',
  total_funding: 'total_funding',
  total_rounds: 'total_rounds',
  value_tags: 'value_tags',
  last_funding_round: 'last_funding_round',
  redirect_slugs: 'redirect_slugs',
  aliases: 'aliases',
  revyse_owner_id: 'revyse_owner_id'
};

exports.Prisma.ProductCategoryScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  highlighted: 'highlighted',
  primary_vendor_type: 'primary_vendor_type',
  secondary_vendor_type: 'secondary_vendor_type',
  slug: 'slug',
  faq_1: 'faq_1',
  faq_1_answer: 'faq_1_answer',
  faq_2: 'faq_2',
  faq_2_answer: 'faq_2_answer',
  faq_3: 'faq_3',
  faq_3_answer: 'faq_3_answer',
  meta_description: 'meta_description',
  page_title: 'page_title',
  resident_lifecycle_phase: 'resident_lifecycle_phase',
  status: 'status'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  title: 'title',
  description: 'description',
  vendor_id: 'vendor_id',
  primary_category_id: 'primary_category_id',
  slug: 'slug',
  demo_scheduling_url: 'demo_scheduling_url',
  lead_prospect_email: 'lead_prospect_email',
  review_questions: 'review_questions',
  secondary_category_id: 'secondary_category_id',
  tertiary_category_id: 'tertiary_category_id',
  banner_file_id: 'banner_file_id',
  logo_file_id: 'logo_file_id',
  positioning: 'positioning',
  approved_at: 'approved_at',
  approved_by_id: 'approved_by_id',
  meta_description: 'meta_description',
  page_title: 'page_title',
  promo_text: 'promo_text',
  demo_storylane_url: 'demo_storylane_url',
  brand_video_urls: 'brand_video_urls',
  state: 'state',
  manager_account_id: 'manager_account_id',
  redirect_slugs: 'redirect_slugs'
};

exports.Prisma.ProductAwardScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  type: 'type',
  year: 'year',
  category: 'category',
  product_id: 'product_id'
};

exports.Prisma.FileScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  title: 'title',
  description: 'description',
  uri: 'uri',
  mime_type: 'mime_type',
  size_kb: 'size_kb',
  doc_ref_id: 'doc_ref_id',
  indexed_at: 'indexed_at',
  index_started_at: 'index_started_at',
  etag: 'etag'
};

exports.Prisma.ProductFeatureScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  product_id: 'product_id',
  order: 'order'
};

exports.Prisma.ProductPackageScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  product_id: 'product_id',
  order: 'order',
  features: 'features',
  button_text: 'button_text',
  button_url: 'button_url',
  price_type: 'price_type',
  price: 'price'
};

exports.Prisma.IndustryScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  slug: 'slug'
};

exports.Prisma.GoodForTagScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  description: 'description',
  slug: 'slug',
  order: 'order'
};

exports.Prisma.VendorIntegrationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  vendor_id: 'vendor_id',
  integrated_vendor_id: 'integrated_vendor_id',
  integrated_product_id: 'integrated_product_id',
  integration_provider: 'integration_provider',
  last_verified_at: 'last_verified_at'
};

exports.Prisma.IntelligenceVendorIntegrationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  vendor_id: 'vendor_id',
  integrated_vendor_id: 'integrated_vendor_id',
  integrated_product_id: 'integrated_product_id',
  status: 'status',
  notes: 'notes'
};

exports.Prisma.ProductReviewScalarFieldEnum = {
  id: 'id',
  product_id: 'product_id',
  user_id: 'user_id',
  approved_by_id: 'approved_by_id',
  decision_maker: 'decision_maker',
  who_uses: 'who_uses',
  primary_use_case: 'primary_use_case',
  like_most: 'like_most',
  dislike_most: 'dislike_most',
  recommend_to: 'recommend_to',
  custom_question_1: 'custom_question_1',
  custom_question_2: 'custom_question_2',
  custom_question_3: 'custom_question_3',
  customer_service_score: 'customer_service_score',
  customer_service_desc: 'customer_service_desc',
  value_score: 'value_score',
  value_desc: 'value_desc',
  onboarding_score: 'onboarding_score',
  onboarding_desc: 'onboarding_desc',
  compatibility_score: 'compatibility_score',
  compatibility_desc: 'compatibility_desc',
  show_last_name: 'show_last_name',
  show_job_title: 'show_job_title',
  show_company: 'show_company',
  responded_by_id: 'responded_by_id',
  response: 'response',
  created_at: 'created_at',
  updated_at: 'updated_at',
  approved_at: 'approved_at',
  responded_at: 'responded_at',
  title: 'title',
  incentivized: 'incentivized',
  vendor_invited: 'vendor_invited',
  response_deleted_at: 'response_deleted_at',
  response_deleted_by_id: 'response_deleted_by_id'
};

exports.Prisma.ProductReviewHelpfulScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  review_id: 'review_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.BuyerDomainScalarFieldEnum = {
  id: 'id',
  domain: 'domain'
};

exports.Prisma.ProductSubscriptionScalarFieldEnum = {
  id: 'id',
  stripe_id: 'stripe_id',
  status: 'status',
  product_id: 'product_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  stripe_price_id: 'stripe_price_id',
  subscription_payment_missed_at: 'subscription_payment_missed_at'
};

exports.Prisma.StripeProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  active: 'active',
  order: 'order',
  tier: 'tier'
};

exports.Prisma.StripePriceScalarFieldEnum = {
  id: 'id',
  product_id: 'product_id',
  price: 'price',
  cadence: 'cadence',
  created_at: 'created_at',
  updated_at: 'updated_at',
  active: 'active'
};

exports.Prisma.BuyerContactRequestScalarFieldEnum = {
  id: 'id',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  opened_at: 'opened_at',
  archived_at: 'archived_at',
  product_id: 'product_id',
  user_id: 'user_id'
};

exports.Prisma.PostScalarFieldEnum = {
  id: 'id',
  status: 'status',
  name: 'name',
  body: 'body',
  slug: 'slug',
  url: 'url',
  space_name: 'space_name',
  space_slug: 'space_slug',
  space_id: 'space_id',
  user_id: 'user_id',
  user_email: 'user_email',
  user_name: 'user_name',
  comments_count: 'comments_count',
  community_id: 'community_id',
  hide_meta_info: 'hide_meta_info',
  user_avatar_url: 'user_avatar_url',
  published_at: 'published_at',
  created_at: 'created_at',
  updated_at: 'updated_at',
  cover_image: 'cover_image',
  cover_image_url: 'cover_image_url',
  cardview_thumbnail: 'cardview_thumbnail',
  cardview_thumbnail_url: 'cardview_thumbnail_url',
  is_comments_enabled: 'is_comments_enabled',
  is_comments_closed: 'is_comments_closed',
  is_liking_enabled: 'is_liking_enabled',
  flagged_for_approval_at: 'flagged_for_approval_at',
  custom_html: 'custom_html',
  likes_count: 'likes_count',
  user_posts_count: 'user_posts_count',
  user_topics_count: 'user_topics_count',
  user_likes_count: 'user_likes_count',
  user_comments_count: 'user_comments_count',
  meta_description: 'meta_description',
  meta_title: 'meta_title'
};

exports.Prisma.LegalDocScalarFieldEnum = {
  id: 'id',
  name: 'name',
  body: 'body',
  slug: 'slug',
  hide_meta_info: 'hide_meta_info',
  meta_title: 'meta_title',
  meta_description: 'meta_description',
  published_at: 'published_at',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ManagerAccountScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  avatar_id: 'avatar_id',
  oauth_organization_id: 'oauth_organization_id',
  enable_zipline_module: 'enable_zipline_module',
  internal: 'internal',
  auto_verify_email_for_sso_users: 'auto_verify_email_for_sso_users',
  enable_ai_contract_module: 'enable_ai_contract_module',
  corporate_default_task_owner_id: 'corporate_default_task_owner_id',
  location_default_property_email: 'location_default_property_email',
  location_default_task_owner_id: 'location_default_task_owner_id',
  fallback_default_task_owner_id: 'fallback_default_task_owner_id',
  contracted_at: 'contracted_at',
  review_days: 'review_days',
  enable_onboarding: 'enable_onboarding',
  location_default_community_manager_email: 'location_default_community_manager_email',
  enable_credentialing_module: 'enable_credentialing_module',
  reminder_cadence_months: 'reminder_cadence_months',
  rw_offboarding_report: 'rw_offboarding_report',
  enable_contract_notifications: 'enable_contract_notifications',
  contract_notification_emails: 'contract_notification_emails',
  enable_contract_execution: 'enable_contract_execution',
  address_street_1: 'address_street_1',
  address_street_2: 'address_street_2',
  address_city: 'address_city',
  address_state: 'address_state',
  address_zipcode: 'address_zipcode',
  zipline_module_version: 'zipline_module_version'
};

exports.Prisma.ManagerAccountRoleScalarFieldEnum = {
  id: 'id',
  role: 'role',
  user_id: 'user_id',
  manager_account_id: 'manager_account_id',
  daily_notification_email: 'daily_notification_email',
  deleted_at: 'deleted_at',
  zipline_notification_email: 'zipline_notification_email',
  location_viewer_enabled: 'location_viewer_enabled'
};

exports.Prisma.ManagerAccountVendorScalarFieldEnum = {
  id: 'id',
  manager_account_id: 'manager_account_id',
  vendor_id: 'vendor_id',
  is_preferred: 'is_preferred',
  created_at: 'created_at',
  updated_at: 'updated_at',
  city: 'city',
  internal_vendor_code: 'internal_vendor_code',
  phone: 'phone',
  state: 'state',
  street_1: 'street_1',
  street_2: 'street_2',
  vendor_since: 'vendor_since',
  zip: 'zip',
  business_criticality_rating: 'business_criticality_rating',
  cybersecurity: 'cybersecurity',
  data_privacy_customers_employees: 'data_privacy_customers_employees',
  data_privacy_prospects_residents: 'data_privacy_prospects_residents',
  internal_review_status: 'internal_review_status',
  vendor_risk_score: 'vendor_risk_score',
  status: 'status',
  country: 'country',
  no_contracts_required: 'no_contracts_required'
};

exports.Prisma.LocationVendorScalarFieldEnum = {
  id: 'id',
  location_id: 'location_id',
  vendor_id: 'vendor_id',
  status: 'status',
  vendor_since: 'vendor_since',
  internal_vendor_code: 'internal_vendor_code',
  street_1: 'street_1',
  street_2: 'street_2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  phone: 'phone',
  created_at: 'created_at',
  updated_at: 'updated_at',
  country: 'country',
  no_contracts_required: 'no_contracts_required'
};

exports.Prisma.LocationVendorDocumentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  file_id: 'file_id',
  location_vendor_id: 'location_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  classification_type: 'classification_type',
  page_count: 'page_count',
  summary: 'summary'
};

exports.Prisma.ManagerAccountVendorContactScalarFieldEnum = {
  id: 'id',
  name: 'name',
  job_title: 'job_title',
  phone: 'phone',
  status: 'status',
  type: 'type',
  manager_account_vendor_id: 'manager_account_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  email: 'email',
  link: 'link',
  notes: 'notes',
  is_preferred: 'is_preferred',
  is_internal_relationship_owner: 'is_internal_relationship_owner',
  archived_at: 'archived_at',
  tags: 'tags'
};

exports.Prisma.LocationVendorContactScalarFieldEnum = {
  id: 'id',
  name: 'name',
  job_title: 'job_title',
  email: 'email',
  link: 'link',
  phone: 'phone',
  notes: 'notes',
  status: 'status',
  type: 'type',
  location_vendor_id: 'location_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_preferred: 'is_preferred',
  is_internal_relationship_owner: 'is_internal_relationship_owner',
  archived_at: 'archived_at',
  tags: 'tags'
};

exports.Prisma.ManagerAccountVendorIncidentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  status: 'status',
  created_date: 'created_date',
  resolved_date: 'resolved_date',
  nature_scope_timing: 'nature_scope_timing',
  impact: 'impact',
  description: 'description',
  next_steps: 'next_steps',
  response_team: 'response_team',
  manager_account_vendor_id: 'manager_account_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ManagerAccountVendorDocumentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  file_id: 'file_id',
  manager_account_vendor_id: 'manager_account_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  is_risk_document: 'is_risk_document',
  classification_type: 'classification_type',
  page_count: 'page_count',
  summary: 'summary'
};

exports.Prisma.ContractFileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  file_id: 'file_id',
  contract_id: 'contract_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  classification_type: 'classification_type',
  page_count: 'page_count',
  summary: 'summary',
  primary: 'primary'
};

exports.Prisma.ContractScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  term_length_months: 'term_length_months',
  expires_at: 'expires_at',
  contract_owner_name: 'contract_owner_name',
  is_msa: 'is_msa',
  renewal_reminder_emails: 'renewal_reminder_emails',
  will_auto_renew: 'will_auto_renew',
  is_corporate_only: 'is_corporate_only',
  status: 'status',
  notes: 'notes',
  approver: 'approver',
  auto_renew_term_length: 'auto_renew_term_length',
  current_term_end_date: 'current_term_end_date',
  is_month_to_month: 'is_month_to_month',
  renewal_reminder_date: 'renewal_reminder_date',
  manager_account_vendor_id: 'manager_account_vendor_id',
  effective_date: 'effective_date',
  task_owner_id: 'task_owner_id',
  termination_notice_details: 'termination_notice_details',
  termination_notice_period: 'termination_notice_period',
  canceled_at: 'canceled_at',
  is_sensitive: 'is_sensitive',
  location_vendor_id: 'location_vendor_id',
  zipline_analyzing_at: 'zipline_analyzing_at',
  zipline_approved_at: 'zipline_approved_at',
  zipline_approved_id: 'zipline_approved_id',
  zipline_approved_locations_at: 'zipline_approved_locations_at',
  zipline_approved_locations_by_id: 'zipline_approved_locations_by_id',
  zipline_approved_pricing_at: 'zipline_approved_pricing_at',
  zipline_approved_pricing_by_id: 'zipline_approved_pricing_by_id',
  zipline_approved_terms_at: 'zipline_approved_terms_at',
  zipline_approved_terms_by_id: 'zipline_approved_terms_by_id',
  zipline_assigned_to_id: 'zipline_assigned_to_id',
  zipline_awaiting_approval_at: 'zipline_awaiting_approval_at',
  zipline_pending_analysis_at: 'zipline_pending_analysis_at',
  zipline_status: 'zipline_status',
  zipline_under_review_at: 'zipline_under_review_at',
  manager_account_id: 'manager_account_id',
  zipline_analysis_issue: 'zipline_analysis_issue',
  zipline_failed_analysis_at: 'zipline_failed_analysis_at',
  zipline_canceled_at: 'zipline_canceled_at',
  zipline_file_uploaded_by_id: 'zipline_file_uploaded_by_id',
  zipline_canceled_reason: 'zipline_canceled_reason',
  disposition_instructions: 'disposition_instructions',
  renewal_reminder_notifications: 'renewal_reminder_notifications',
  renewal_reminder_cadence: 'renewal_reminder_cadence',
  renewal_term_is_month_to_month: 'renewal_term_is_month_to_month',
  is_open_ended: 'is_open_ended',
  zipline_saved_details_at: 'zipline_saved_details_at',
  zipline_saved_renewal_reminder_at: 'zipline_saved_renewal_reminder_at',
  zipline_saved_departments_at: 'zipline_saved_departments_at',
  zipline_saved_line_items_at: 'zipline_saved_line_items_at',
  zipline_saved_locations_at: 'zipline_saved_locations_at',
  zipline_started_locations_at: 'zipline_started_locations_at',
  zipline_started_pricing_at: 'zipline_started_pricing_at',
  zipline_started_terms_at: 'zipline_started_terms_at',
  renewal_details: 'renewal_details',
  property_email: 'property_email',
  default_entity: 'default_entity',
  community_manager_email: 'community_manager_email',
  contract_execution_id: 'contract_execution_id'
};

exports.Prisma.ContractLineItemScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  contract_id: 'contract_id',
  is_corporate_only: 'is_corporate_only',
  cadence: 'cadence',
  discount: 'discount',
  price: 'price',
  price_increase_percent: 'price_increase_percent',
  pricing_type: 'pricing_type',
  setup_fee: 'setup_fee',
  seats_number: 'seats_number',
  price_increase_cadence: 'price_increase_cadence',
  estimated_cost: 'estimated_cost',
  canceled_at: 'canceled_at',
  status: 'status',
  notes: 'notes',
  contract_line_item_items: 'contract_line_item_items',
  zipline_status: 'zipline_status',
  zipline_status_locations: 'zipline_status_locations',
  zipline_visited_locations: 'zipline_visited_locations',
  monthly_cadence_months: 'monthly_cadence_months',
  weekly_cadence_length: 'weekly_cadence_length',
  category_id: 'category_id',
  type: 'type',
  is_zero_dollar_line_item: 'is_zero_dollar_line_item',
  percentage_based_percentage: 'percentage_based_percentage'
};

exports.Prisma.FeeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  vendor_id: 'vendor_id',
  category_id: 'category_id',
  manager_account_id: 'manager_account_id'
};

exports.Prisma.ContractLineItemFeeScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  price: 'price',
  contract_line_item_id: 'contract_line_item_id',
  fee_id: 'fee_id',
  department_id: 'department_id',
  cost_per_hour: 'cost_per_hour',
  hours_quantity: 'hours_quantity'
};

exports.Prisma.DepartmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  manager_account_id: 'manager_account_id',
  state: 'state',
  is_default: 'is_default'
};

exports.Prisma.ContractLocationFileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  file_id: 'file_id',
  contract_id: 'contract_id',
  location_id: 'location_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  classification_type: 'classification_type',
  page_count: 'page_count',
  summary: 'summary'
};

exports.Prisma.ContractLineItemLocationScalarFieldEnum = {
  id: 'id',
  expires_at: 'expires_at',
  contract_line_item_id: 'contract_line_item_id',
  location_id: 'location_id',
  canceled_at: 'canceled_at',
  final_vendor_statement_principal: 'final_vendor_statement_principal',
  final_vendor_statement_file_id: 'final_vendor_statement_file_id',
  status: 'status'
};

exports.Prisma.ContractAIExtractScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  contract_id: 'contract_id',
  initiated_by_id: 'initiated_by_id',
  completed_at: 'completed_at',
  status: 'status'
};

exports.Prisma.ContractAIExtractFieldScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  contract_ai_extract_id: 'contract_ai_extract_id',
  field_name: 'field_name',
  field_value: 'field_value',
  prompt_version: 'prompt_version',
  model_used: 'model_used',
  confidence: 'confidence',
  reasoning: 'reasoning',
  reference: 'reference',
  feedback: 'feedback',
  prompt: 'prompt',
  response: 'response',
  context: 'context',
  completed_at: 'completed_at',
  status: 'status'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  pms_id: 'pms_id',
  owner_name: 'owner_name',
  street_1: 'street_1',
  street_2: 'street_2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  region: 'region',
  unit_count: 'unit_count',
  class: 'class',
  created_at: 'created_at',
  updated_at: 'updated_at',
  manager_account_id: 'manager_account_id',
  status: 'status',
  property_stage: 'property_stage',
  property_type: 'property_type',
  country: 'country',
  external_id: 'external_id',
  email: 'email',
  community_manager_email: 'community_manager_email'
};

exports.Prisma.LocationGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  manager_account_id: 'manager_account_id'
};

exports.Prisma.LocationGroupRoleScalarFieldEnum = {
  id: 'id',
  role: 'role',
  user_id: 'user_id',
  location_group_id: 'location_group_id'
};

exports.Prisma.TaskContractRenewalScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  start_date: 'start_date',
  due_date: 'due_date',
  current_term_end_date: 'current_term_end_date',
  renewal_reminder_date: 'renewal_reminder_date',
  schedule_status: 'schedule_status',
  completion_status: 'completion_status',
  contract_id: 'contract_id',
  task_owner_id: 'task_owner_id',
  group_chat_id: 'group_chat_id',
  next_auto_renew_term_length: 'next_auto_renew_term_length',
  next_current_term_end_date: 'next_current_term_end_date'
};

exports.Prisma.TaskLocationDispositionScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  start_date: 'start_date',
  due_date: 'due_date',
  schedule_status: 'schedule_status',
  completion_status: 'completion_status',
  task_owner_id: 'task_owner_id',
  group_chat_id: 'group_chat_id',
  completed_with: 'completed_with',
  location_id: 'location_id'
};

exports.Prisma.IntelligenceNotificationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  manager_account_role_id: 'manager_account_role_id',
  type: 'type',
  read: 'read',
  archived: 'archived',
  archived_at: 'archived_at',
  metadata: 'metadata',
  message: 'message'
};

exports.Prisma.GroupChatScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  sender_id: 'sender_id',
  content: 'content',
  group_chat_id: 'group_chat_id'
};

exports.Prisma.MessageFileScalarFieldEnum = {
  id: 'id',
  file_id: 'file_id',
  message_id: 'message_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ReactionScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  type: 'type',
  message_id: 'message_id',
  sender_id: 'sender_id'
};

exports.Prisma.GeneralLedgerImportScalarFieldEnum = {
  id: 'id',
  imported_at: 'imported_at',
  manager_account_id: 'manager_account_id',
  standard: 'standard',
  extraction_results: 'extraction_results'
};

exports.Prisma.GeneralLedgerImportRowScalarFieldEnum = {
  id: 'id',
  parsed_vendor_name: 'parsed_vendor_name',
  parsed_line_item_name: 'parsed_line_item_name',
  general_ledger_import_id: 'general_ledger_import_id',
  row_data: 'row_data'
};

exports.Prisma.GeneralLedgerImportStandardConfigScalarFieldEnum = {
  standard: 'standard',
  exclude_patterns: 'exclude_patterns'
};

exports.Prisma.ZiplineExtendWorkflowScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  extracted_data: 'extracted_data',
  contract_includes_msa: 'contract_includes_msa',
  contract_length: 'contract_length',
  customer_company_name: 'customer_company_name',
  effective_date: 'effective_date',
  is_auto_renewing: 'is_auto_renewing',
  is_month_to_month: 'is_month_to_month',
  renewal_clause_text: 'renewal_clause_text',
  vendor_company_name: 'vendor_company_name',
  status: 'status',
  contract_includes_msa_confidence: 'contract_includes_msa_confidence',
  contract_length_confidence: 'contract_length_confidence',
  customer_company_name_confidence: 'customer_company_name_confidence',
  effective_date_confidence: 'effective_date_confidence',
  is_auto_renewing_confidence: 'is_auto_renewing_confidence',
  is_month_to_month_confidence: 'is_month_to_month_confidence',
  renewal_clause_text_confidence: 'renewal_clause_text_confidence',
  vendor_company_name_confidence: 'vendor_company_name_confidence',
  dashboard_link: 'dashboard_link',
  termination_notice_details: 'termination_notice_details',
  termination_notice_details_confidence: 'termination_notice_details_confidence',
  contract_file_id: 'contract_file_id',
  disposition_instructions: 'disposition_instructions',
  disposition_instructions_confidence: 'disposition_instructions_confidence',
  classification_type: 'classification_type',
  page_count: 'page_count',
  summary: 'summary',
  summary_confidence: 'summary_confidence',
  renewal_term: 'renewal_term',
  renewal_term_confidence: 'renewal_term_confidence',
  extend_file_created_at: 'extend_file_created_at',
  extend_file_raw_content: 'extend_file_raw_content',
  extend_file_updated_at: 'extend_file_updated_at',
  termination_notice_period: 'termination_notice_period',
  termination_notice_period_confidence: 'termination_notice_period_confidence',
  renewal_is_month_to_month: 'renewal_is_month_to_month',
  renewal_is_month_to_month_confidence: 'renewal_is_month_to_month_confidence',
  customer_signature: 'customer_signature',
  customer_signature_confidence: 'customer_signature_confidence',
  vendor_signature: 'vendor_signature',
  vendor_signature_confidence: 'vendor_signature_confidence',
  contract_includes_rebate: 'contract_includes_rebate',
  contract_includes_rebate_confidence: 'contract_includes_rebate_confidence',
  contract_includes_sponsorship: 'contract_includes_sponsorship',
  contract_includes_sponsorship_confidence: 'contract_includes_sponsorship_confidence',
  rebate_details: 'rebate_details',
  rebate_details_confidence: 'rebate_details_confidence',
  sponsorship_details: 'sponsorship_details',
  sponsorship_details_confidence: 'sponsorship_details_confidence'
};

exports.Prisma.ZiplineExtendWebhookEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  zipline_extend_workflow_id: 'zipline_extend_workflow_id',
  extend_event_id: 'extend_event_id',
  extend_event_type: 'extend_event_type',
  payload: 'payload'
};

exports.Prisma.RVIAutoExtendWorkflowScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  file_id: 'file_id',
  status: 'status',
  classification_type: 'classification_type',
  page_count: 'page_count',
  extend_file_created_at: 'extend_file_created_at',
  extend_file_updated_at: 'extend_file_updated_at',
  summary: 'summary',
  summary_confidence: 'summary_confidence',
  extracted_data: 'extracted_data',
  customer_signature: 'customer_signature',
  customer_signature_confidence: 'customer_signature_confidence',
  vendor_signature: 'vendor_signature',
  vendor_signature_confidence: 'vendor_signature_confidence'
};

exports.Prisma.RVIContractExtendWorkflowScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  file_id: 'file_id',
  status: 'status',
  classification_type: 'classification_type',
  page_count: 'page_count',
  extend_file_raw_content: 'extend_file_raw_content',
  extend_file_created_at: 'extend_file_created_at',
  extend_file_updated_at: 'extend_file_updated_at',
  summary: 'summary',
  summary_confidence: 'summary_confidence',
  vendor_company_name: 'vendor_company_name',
  vendor_company_name_confidence: 'vendor_company_name_confidence',
  customer_company_name: 'customer_company_name',
  customer_company_name_confidence: 'customer_company_name_confidence',
  contract_length: 'contract_length',
  contract_length_confidence: 'contract_length_confidence',
  effective_date: 'effective_date',
  effective_date_confidence: 'effective_date_confidence',
  contract_includes_msa: 'contract_includes_msa',
  contract_includes_msa_confidence: 'contract_includes_msa_confidence',
  is_month_to_month: 'is_month_to_month',
  is_month_to_month_confidence: 'is_month_to_month_confidence',
  renewal_clause_text: 'renewal_clause_text',
  renewal_clause_text_confidence: 'renewal_clause_text_confidence',
  termination_notice_details: 'termination_notice_details',
  termination_notice_details_confidence: 'termination_notice_details_confidence',
  termination_notice_period: 'termination_notice_period',
  termination_notice_period_confidence: 'termination_notice_period_confidence',
  is_auto_renewing: 'is_auto_renewing',
  is_auto_renewing_confidence: 'is_auto_renewing_confidence',
  renewal_term: 'renewal_term',
  renewal_term_confidence: 'renewal_term_confidence',
  renewal_is_month_to_month: 'renewal_is_month_to_month',
  renewal_is_month_to_month_confidence: 'renewal_is_month_to_month_confidence',
  disposition_instructions: 'disposition_instructions',
  disposition_instructions_confidence: 'disposition_instructions_confidence',
  dashboard_link: 'dashboard_link',
  extracted_data: 'extracted_data',
  customer_signature: 'customer_signature',
  customer_signature_confidence: 'customer_signature_confidence',
  vendor_signature: 'vendor_signature',
  vendor_signature_confidence: 'vendor_signature_confidence',
  contract_includes_rebate: 'contract_includes_rebate',
  contract_includes_rebate_confidence: 'contract_includes_rebate_confidence',
  contract_includes_sponsorship: 'contract_includes_sponsorship',
  contract_includes_sponsorship_confidence: 'contract_includes_sponsorship_confidence',
  rebate_details: 'rebate_details',
  rebate_details_confidence: 'rebate_details_confidence',
  sponsorship_details: 'sponsorship_details',
  sponsorship_details_confidence: 'sponsorship_details_confidence'
};

exports.Prisma.RVIContractExtendWebhookEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  extend_event_id: 'extend_event_id',
  extend_event_type: 'extend_event_type',
  payload: 'payload',
  rvi_contract_extend_workflow_id: 'rvi_contract_extend_workflow_id'
};

exports.Prisma.RVIAutoExtendWorkflowEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  extend_event_id: 'extend_event_id',
  extend_event_type: 'extend_event_type',
  payload: 'payload',
  rvi_auto_extend_workflow_id: 'rvi_auto_extend_workflow_id'
};

exports.Prisma.LocationNoticeDispositionScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status',
  status_updated_at: 'status_updated_at',
  step: 'step',
  disposition_date: 'disposition_date',
  termination_date: 'termination_date',
  termination_instructions: 'termination_instructions',
  email_subject: 'email_subject',
  email_body: 'email_body',
  email_cc_emails: 'email_cc_emails',
  location_id: 'location_id',
  task_owner_id: 'task_owner_id',
  manager_account_role_id: 'manager_account_role_id',
  original_location_notice_id: 'original_location_notice_id',
  location_disposition_task_id: 'location_disposition_task_id'
};

exports.Prisma.LocationServiceTerminationNoticeScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status',
  status_updated_at: 'status_updated_at',
  step: 'step',
  termination_date: 'termination_date',
  termination_instructions: 'termination_instructions',
  manager_account_vendor_id: 'manager_account_vendor_id',
  contact_name: 'contact_name',
  contact_email: 'contact_email',
  email_subject: 'email_subject',
  email_body: 'email_body',
  email_cc_emails: 'email_cc_emails',
  location_id: 'location_id',
  task_owner_id: 'task_owner_id',
  manager_account_role_id: 'manager_account_role_id',
  original_location_notice_id: 'original_location_notice_id',
  location_vendor_id: 'location_vendor_id',
  sent_by_email: 'sent_by_email',
  sent_by_name: 'sent_by_name'
};

exports.Prisma.ServiceTerminationContractLineItemScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  cadence: 'cadence',
  price: 'price',
  pricing_type: 'pricing_type',
  seats_number: 'seats_number',
  contract_line_item_id: 'contract_line_item_id'
};

exports.Prisma.LocationNoticeDispositionRecipientScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  name: 'name',
  email: 'email',
  location_notice_id: 'location_notice_id',
  manager_account_vendor_id: 'manager_account_vendor_id',
  location_vendor_id: 'location_vendor_id'
};

exports.Prisma.LocationRoleScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  type: 'type',
  location_id: 'location_id',
  manager_account_role_id: 'manager_account_role_id',
  imported: 'imported'
};

exports.Prisma.UserImpersonationScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  user_id: 'user_id',
  impersonated_user_id: 'impersonated_user_id',
  deactivated_at: 'deactivated_at'
};

exports.Prisma.OAuthCredentialScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  user_id: 'user_id',
  provider: 'provider',
  access_token: 'access_token',
  refresh_token: 'refresh_token',
  access_token_expiry: 'access_token_expiry'
};

exports.Prisma.PostAliasScalarFieldEnum = {
  id: 'id',
  old_slug: 'old_slug',
  post_id: 'post_id'
};

exports.Prisma.ComplianceProgramCredentialInvitationScalarFieldEnum = {
  id: 'id',
  compliance_program_credential_id: 'compliance_program_credential_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  accepted_at: 'accepted_at',
  email_invited: 'email_invited',
  email_reminder_count: 'email_reminder_count',
  email_reminder_sent_at: 'email_reminder_sent_at',
  accepted_by_id: 'accepted_by_id',
  enrolled_by_id: 'enrolled_by_id',
  deleted_at: 'deleted_at'
};

exports.Prisma.ComplianceProgramCredentialScalarFieldEnum = {
  id: 'id',
  compliance_program_id: 'compliance_program_id',
  location_vendor_id: 'location_vendor_id',
  manager_account_vendor_id: 'manager_account_vendor_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status'
};

exports.Prisma.ComplianceProgramESignWorkflowScalarFieldEnum = {
  id: 'id',
  compliance_program_id: 'compliance_program_id',
  esign_workflow_id: 'esign_workflow_id',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.ESignWorkflowScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  activated_at: 'activated_at',
  expiration_period_from_signing_months: 'expiration_period_from_signing_months',
  manager_account_id: 'manager_account_id',
  external_template_id: 'external_template_id',
  template_file_id: 'template_file_id',
  status: 'status'
};

exports.Prisma.ESignWorkflowRunScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  esign_workflow_id: 'esign_workflow_id',
  compliance_program_credential_id: 'compliance_program_credential_id',
  rejected_at: 'rejected_at',
  rejection_reason: 'rejection_reason',
  question: 'question',
  status: 'status',
  signed_at: 'signed_at',
  signed_by_id: 'signed_by_id'
};

exports.Prisma.ESignDocumentScalarFieldEnum = {
  id: 'id',
  external_id: 'external_id',
  file_id: 'file_id',
  esign_workflowRun_id: 'esign_workflowRun_id',
  location_vendor_role_id: 'location_vendor_role_id',
  manager_account_vendor_role_id: 'manager_account_vendor_role_id'
};

exports.Prisma.ESignWorkflowRunEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  esign_workflow_run_id: 'esign_workflow_run_id',
  event_type: 'event_type',
  event_data: 'event_data'
};

exports.Prisma.ManagerAccountVendorRoleScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  role: 'role',
  user_id: 'user_id',
  manager_account_vendor_id: 'manager_account_vendor_id'
};

exports.Prisma.LocationVendorRoleScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  role: 'role',
  user_id: 'user_id',
  location_vendor_id: 'location_vendor_id'
};

exports.Prisma.PmsVendorInfoScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  manager_account_vendor_id: 'manager_account_vendor_id',
  location_vendor_id: 'location_vendor_id',
  vendor_code: 'vendor_code',
  address: 'address',
  city: 'city',
  state: 'state',
  zip: 'zip',
  fed_id: 'fed_id',
  office_phone: 'office_phone',
  email: 'email'
};

exports.Prisma.ComplianceProgramScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  manager_account_id: 'manager_account_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  needs_requirements: 'needs_requirements'
};

exports.Prisma.ContractTemplateEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  event_type: 'event_type',
  event_data: 'event_data',
  contract_template_id: 'contract_template_id'
};

exports.Prisma.ContractTemplateScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  status: 'status',
  name: 'name',
  description: 'description',
  last_saved_step: 'last_saved_step',
  manager_account_id: 'manager_account_id'
};

exports.Prisma.ContractTemplateVersionScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  version: 'version',
  is_msa: 'is_msa',
  term_length_months: 'term_length_months',
  will_auto_renew: 'will_auto_renew',
  renewal_details: 'renewal_details',
  auto_renew_term_length: 'auto_renew_term_length',
  is_month_to_month: 'is_month_to_month',
  is_open_ended: 'is_open_ended',
  termination_notice_details: 'termination_notice_details',
  termination_notice_period: 'termination_notice_period',
  disposition_instructions: 'disposition_instructions',
  contract_template_id: 'contract_template_id'
};

exports.Prisma.ContractTemplateVariableScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  variable_name: 'variable_name',
  custom_label: 'custom_label',
  amount_format: 'amount_format',
  is_auto_populated: 'is_auto_populated',
  contract_template_content_id: 'contract_template_content_id',
  contract_template_entry_version_id: 'contract_template_entry_version_id'
};

exports.Prisma.ContractTemplateContentScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  content: 'content',
  contract_template_version_id: 'contract_template_version_id'
};

exports.Prisma.ContractTemplateEntryScalarFieldEnum = {
  id: 'id',
  status: 'status',
  name: 'name',
  description: 'description',
  created_at: 'created_at',
  updated_at: 'updated_at',
  manager_account_id: 'manager_account_id'
};

exports.Prisma.ContractTemplateEntryVersionScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  version: 'version',
  multiple_selection: 'multiple_selection',
  contract_template_entry_id: 'contract_template_entry_id'
};

exports.Prisma.ContractTemplateEntryOptionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  content: 'content',
  created_at: 'created_at',
  updated_at: 'updated_at',
  in_progress: 'in_progress',
  contract_template_entry_version_id: 'contract_template_entry_version_id'
};

exports.Prisma.ContractTemplateEntryOptionVariableScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  variable_name: 'variable_name',
  custom_label: 'custom_label',
  amount_format: 'amount_format',
  is_auto_populated: 'is_auto_populated',
  contract_template_entry_option_id: 'contract_template_entry_option_id'
};

exports.Prisma.ContractExecutionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  contract_template_version_id: 'contract_template_version_id',
  type: 'type',
  manager_account_id: 'manager_account_id',
  location_vendor_id: 'location_vendor_id',
  manager_account_vendor_id: 'manager_account_vendor_id',
  signer_email: 'signer_email',
  signer_name: 'signer_name',
  signer_manager_account_vendor_role_id: 'signer_manager_account_vendor_role_id',
  signer_location_vendor_role_id: 'signer_location_vendor_role_id',
  countersigner_id: 'countersigner_id',
  status: 'status',
  last_saved_step: 'last_saved_step',
  link_expiration_date: 'link_expiration_date',
  sent_at: 'sent_at',
  effective_date: 'effective_date',
  initial_term_end_date: 'initial_term_end_date',
  current_term_end_date: 'current_term_end_date',
  renewal_reminder_notifications: 'renewal_reminder_notifications',
  renewal_reminder_date: 'renewal_reminder_date',
  renewal_reminder_cadence: 'renewal_reminder_cadence',
  renewal_reminder_emails: 'renewal_reminder_emails',
  task_owner_id: 'task_owner_id',
  property_email_as_task_owner: 'property_email_as_task_owner',
  community_manager_email_as_task_owner: 'community_manager_email_as_task_owner',
  rejection_reason: 'rejection_reason',
  comments: 'comments',
  rejection_comments: 'rejection_comments'
};

exports.Prisma.ContractExecutionVariableValueScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  value: 'value',
  rank: 'rank',
  contract_execution_id: 'contract_execution_id',
  contract_template_variable_id: 'contract_template_variable_id',
  contract_template_entry_option_id: 'contract_template_entry_option_id'
};

exports.Prisma.ContractExecutionEntryOptionVariableValueScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  value: 'value',
  contract_execution_variable_value_id: 'contract_execution_variable_value_id',
  contract_template_entry_option_variable_id: 'contract_template_entry_option_variable_id'
};

exports.Prisma.ContractExecutionSupportingFileScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  file_id: 'file_id',
  contract_execution_id: 'contract_execution_id',
  name: 'name'
};

exports.Prisma.ContractExecutionEventScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  event_type: 'event_type',
  event_data: 'event_data',
  contract_execution_id: 'contract_execution_id'
};

exports.Prisma.ContractExecutionDocumentScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  original_file_id: 'original_file_id',
  completed_file_id: 'completed_file_id',
  vendor_signed_file_id: 'vendor_signed_file_id',
  esign_document_external_id: 'esign_document_external_id',
  esign_template_external_id: 'esign_template_external_id',
  contract_execution_id: 'contract_execution_id'
};

exports.Prisma.ContractExecutionLineItemScalarFieldEnum = {
  id: 'id',
  name: 'name',
  created_at: 'created_at',
  updated_at: 'updated_at',
  contract_execution_id: 'contract_execution_id',
  is_corporate_only: 'is_corporate_only',
  cadence: 'cadence',
  discount: 'discount',
  price: 'price',
  price_increase_percent: 'price_increase_percent',
  pricing_type: 'pricing_type',
  setup_fee: 'setup_fee',
  seats_number: 'seats_number',
  price_increase_cadence: 'price_increase_cadence',
  estimated_cost: 'estimated_cost',
  notes: 'notes',
  contract_line_item_items: 'contract_line_item_items',
  monthly_cadence_months: 'monthly_cadence_months',
  weekly_cadence_length: 'weekly_cadence_length',
  category_id: 'category_id',
  type: 'type',
  is_zero_dollar_line_item: 'is_zero_dollar_line_item',
  percentage_based_percentage: 'percentage_based_percentage'
};

exports.Prisma.ContractExecutionLineItemFeeScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  price: 'price',
  contract_execution_line_item_id: 'contract_execution_line_item_id',
  fee_id: 'fee_id',
  department_id: 'department_id',
  cost_per_hour: 'cost_per_hour',
  hours_quantity: 'hours_quantity'
};

exports.Prisma.ContractExecutionLineItemLocationScalarFieldEnum = {
  id: 'id',
  expires_at: 'expires_at',
  contract_execution_line_item_id: 'contract_execution_line_item_id',
  location_id: 'location_id'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.SignUpIntent = exports.$Enums.SignUpIntent = {
  ORGANIC: 'ORGANIC',
  BUYER: 'BUYER',
  VENDOR: 'VENDOR'
};

exports.Role = exports.$Enums.Role = {
  GOD_MODE: 'GOD_MODE',
  BUYER: 'BUYER',
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  RVI_SUPPORT: 'RVI_SUPPORT'
};

exports.UserRoleType = exports.$Enums.UserRoleType = {
  GLOBAL: 'GLOBAL',
  PRODUCT_SUBSCRIPTION: 'PRODUCT_SUBSCRIPTION'
};

exports.UserInvitationEventType = exports.$Enums.UserInvitationEventType = {
  InvitationSent: 'InvitationSent',
  InvitationManualReSent: 'InvitationManualReSent',
  InvitationReSent: 'InvitationReSent',
  FinalInvitationReSent: 'FinalInvitationReSent'
};

exports.VendorState = exports.$Enums.VendorState = {
  ApprovedForPublishing: 'ApprovedForPublishing',
  NotApproved: 'NotApproved',
  RevyseIntelligenceOnly: 'RevyseIntelligenceOnly'
};

exports.VendorCompanyStatus = exports.$Enums.VendorCompanyStatus = {
  Private: 'Private',
  Public: 'Public',
  Other: 'Other'
};

exports.VendorLastFundingRound = exports.$Enums.VendorLastFundingRound = {
  PreSeed: 'PreSeed',
  Seed: 'Seed',
  SeriesA: 'SeriesA',
  SeriesB: 'SeriesB',
  SeriesC: 'SeriesC',
  SeriesDPlus: 'SeriesDPlus',
  IPO: 'IPO',
  Other: 'Other',
  NotSet: 'NotSet',
  None: 'None',
  VentureRound: 'VentureRound',
  PrivateEquityRound: 'PrivateEquityRound',
  DebtFinancing: 'DebtFinancing',
  SecondaryMarket: 'SecondaryMarket',
  PostIPOEquity: 'PostIPOEquity',
  PostIPODebt: 'PostIPODebt'
};

exports.VendorValueTags = exports.$Enums.VendorValueTags = {
  MinorityWomenOwned: 'MinorityWomenOwned',
  FoundationsForRentalHousing: 'FoundationsForRentalHousing',
  RevyseForStartups: 'RevyseForStartups'
};

exports.ResidentLifecyclePhase = exports.$Enums.ResidentLifecyclePhase = {
  Shopping: 'Shopping',
  Touring: 'Touring',
  Leasing: 'Leasing',
  Application: 'Application',
  MoveIn: 'MoveIn',
  Residency: 'Residency',
  Retention: 'Retention',
  MoveOut: 'MoveOut',
  None: 'None',
  EnterpriseCorporateTech: 'EnterpriseCorporateTech',
  EnterprisePropertyTech: 'EnterprisePropertyTech',
  ProfessionalServices: 'ProfessionalServices',
  OnsiteSuppliers: 'OnsiteSuppliers'
};

exports.ProductCategoryStatus = exports.$Enums.ProductCategoryStatus = {
  ApprovedForPublishing: 'ApprovedForPublishing',
  RevyseIntelligenceOnly: 'RevyseIntelligenceOnly',
  NotApproved: 'NotApproved'
};

exports.ProductState = exports.$Enums.ProductState = {
  discovery: 'discovery',
  intelligence: 'intelligence',
  internal: 'internal'
};

exports.ProductAwardType = exports.$Enums.ProductAwardType = {
  MostLoved: 'MostLoved',
  SupportStar: 'SupportStar',
  BestValue: 'BestValue'
};

exports.ProductAwardYear = exports.$Enums.ProductAwardYear = {
  Year2025: 'Year2025'
};

exports.IntegrationProvider = exports.$Enums.IntegrationProvider = {
  Revyse: 'Revyse',
  Propexo: 'Propexo'
};

exports.IntelligenceVendorIntegrationStatus = exports.$Enums.IntelligenceVendorIntegrationStatus = {
  Active: 'Active',
  Pending: 'Pending',
  Inactive: 'Inactive'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  trialing: 'trialing',
  active: 'active',
  incomplete: 'incomplete',
  incomplete_expired: 'incomplete_expired',
  past_due: 'past_due',
  canceled: 'canceled',
  unpaid: 'unpaid'
};

exports.Tier = exports.$Enums.Tier = {
  free: 'free',
  tier_1: 'tier_1',
  tier_2: 'tier_2',
  tier_3: 'tier_3'
};

exports.StripePriceCadence = exports.$Enums.StripePriceCadence = {
  monthly: 'monthly',
  yearly: 'yearly'
};

exports.ZiplineModuleVersion = exports.$Enums.ZiplineModuleVersion = {
  v1: 'v1',
  v2: 'v2'
};

exports.ManagerAccountRoleType = exports.$Enums.ManagerAccountRoleType = {
  CompanyOwner: 'CompanyOwner',
  CompanyAdmin: 'CompanyAdmin',
  CompanyEditor: 'CompanyEditor',
  CorporateEditor: 'CorporateEditor',
  CorporateViewer: 'CorporateViewer',
  Member: 'Member'
};

exports.ManagerAccountVendorBusinessCriticalityRating = exports.$Enums.ManagerAccountVendorBusinessCriticalityRating = {
  NotSet: 'NotSet',
  Zero: 'Zero',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  VeryHigh: 'VeryHigh'
};

exports.ManagerAccountVendorDataPrivacyOptions = exports.$Enums.ManagerAccountVendorDataPrivacyOptions = {
  NotSet: 'NotSet',
  Yes: 'Yes',
  No: 'No',
  Unknown: 'Unknown'
};

exports.ManagerAccountVendorInternalReviewStatus = exports.$Enums.ManagerAccountVendorInternalReviewStatus = {
  NotSet: 'NotSet',
  InProgress: 'InProgress',
  Passed: 'Passed',
  Failed: 'Failed'
};

exports.ManagerAccountVendorRiskScore = exports.$Enums.ManagerAccountVendorRiskScore = {
  NotSet: 'NotSet',
  Zero: 'Zero',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  VeryHigh: 'VeryHigh'
};

exports.ManagerAccountVendorStatus = exports.$Enums.ManagerAccountVendorStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Piloting: 'Piloting'
};

exports.LocationCountry = exports.$Enums.LocationCountry = {
  Canada: 'Canada',
  USA: 'USA'
};

exports.ManagerAccountVendorCybersecurityOptions = exports.$Enums.ManagerAccountVendorCybersecurityOptions = {
  NistCybersecurityFramework: 'NistCybersecurityFramework',
  Iso27000Series: 'Iso27000Series',
  Soc2Type1: 'Soc2Type1',
  Soc2Type2: 'Soc2Type2',
  PciDss: 'PciDss',
  NercCip: 'NercCip',
  Cobit: 'Cobit',
  Fisma: 'Fisma',
  Ofdss: 'Ofdss',
  Other: 'Other',
  NA: 'NA'
};

exports.ManagerAccountVendorDocumentType = exports.$Enums.ManagerAccountVendorDocumentType = {
  CybersecurityReport: 'CybersecurityReport',
  DataPrivacyAgreement: 'DataPrivacyAgreement',
  Insurance: 'Insurance',
  ITQuestionnaire: 'ITQuestionnaire',
  PrivacyPolicy: 'PrivacyPolicy',
  SalesAndMarketingMaterials: 'SalesAndMarketingMaterials',
  ScopeOfWork: 'ScopeOfWork',
  TermsofService: 'TermsofService',
  W9: 'W9',
  Other: 'Other',
  Proposal: 'Proposal',
  UtilityDocument: 'UtilityDocument'
};

exports.ExtendWorkflowClassificationType = exports.$Enums.ExtendWorkflowClassificationType = {
  CONTRACT: 'CONTRACT',
  OTHER: 'OTHER',
  ORDER_FORM: 'ORDER_FORM',
  ADDENDUM: 'ADDENDUM',
  AMENDMENT: 'AMENDMENT',
  COI: 'COI',
  W9: 'W9',
  PMA: 'PMA'
};

exports.RviVendorContactStatus = exports.$Enums.RviVendorContactStatus = {
  Active: 'Active',
  Archived: 'Archived'
};

exports.ManagerAccountVendorContactType = exports.$Enums.ManagerAccountVendorContactType = {
  Main: 'Main',
  Support: 'Support',
  Billing: 'Billing',
  Internal: 'Internal',
  Disposition: 'Disposition'
};

exports.RviVendorContactTag = exports.$Enums.RviVendorContactTag = {
  esigner: 'esigner',
  pms: 'pms'
};

exports.LocationVendorContactType = exports.$Enums.LocationVendorContactType = {
  Main: 'Main',
  Support: 'Support',
  Billing: 'Billing',
  Internal: 'Internal',
  Disposition: 'Disposition'
};

exports.ManagerAccountVendorIncidentStatus = exports.$Enums.ManagerAccountVendorIncidentStatus = {
  New: 'New',
  InProgress: 'InProgress',
  UnderInvestigation: 'UnderInvestigation',
  Resolved: 'Resolved'
};

exports.ManagerAccountVendorIncidentImpact = exports.$Enums.ManagerAccountVendorIncidentImpact = {
  NotSet: 'NotSet',
  Zero: 'Zero',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  VeryHigh: 'VeryHigh'
};

exports.ContractStatus = exports.$Enums.ContractStatus = {
  Active: 'Active',
  Pending: 'Pending',
  Canceled: 'Canceled'
};

exports.ZiplineStatus = exports.$Enums.ZiplineStatus = {
  PendingAnalysis: 'PendingAnalysis',
  Analyzing: 'Analyzing',
  UnderReview: 'UnderReview',
  AwaitingApproval: 'AwaitingApproval',
  Approved: 'Approved',
  FailedAnalysis: 'FailedAnalysis',
  Canceled: 'Canceled'
};

exports.ContractLineItemPriceCadence = exports.$Enums.ContractLineItemPriceCadence = {
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  Annual: 'Annual',
  OneTime: 'OneTime',
  Weekly: 'Weekly'
};

exports.ContractPricingType = exports.$Enums.ContractPricingType = {
  FlatRate: 'FlatRate',
  PerLocation: 'PerLocation',
  PerUnit: 'PerUnit',
  PerSeat: 'PerSeat',
  UsageBased: 'UsageBased',
  PerLease: 'PerLease',
  Itemized: 'Itemized',
  PerResident: 'PerResident',
  PerHour: 'PerHour',
  PercentageBased: 'PercentageBased'
};

exports.ContractLineItemPriceIncreaseCadence = exports.$Enums.ContractLineItemPriceIncreaseCadence = {
  IncreaseAtRenewal: 'IncreaseAtRenewal',
  AnnualIncrease: 'AnnualIncrease'
};

exports.ContractLineItemStatus = exports.$Enums.ContractLineItemStatus = {
  Active: 'Active',
  Canceled: 'Canceled',
  Pending: 'Pending'
};

exports.ContractLineItemZiplineStatus = exports.$Enums.ContractLineItemZiplineStatus = {
  Pending: 'Pending',
  Approved: 'Approved'
};

exports.ContractLineItemZiplineStatusLocations = exports.$Enums.ContractLineItemZiplineStatusLocations = {
  Pending: 'Pending',
  Approved: 'Approved'
};

exports.ContractLineItemType = exports.$Enums.ContractLineItemType = {
  Expense: 'Expense',
  Rebate: 'Rebate',
  Revenue: 'Revenue',
  Sponsorship: 'Sponsorship'
};

exports.DepartmentState = exports.$Enums.DepartmentState = {
  AnyContract: 'AnyContract',
  CorporateManagedContracts: 'CorporateManagedContracts',
  LocationManagedContracts: 'LocationManagedContracts'
};

exports.ContractLineItemLocationStatus = exports.$Enums.ContractLineItemLocationStatus = {
  Active: 'Active',
  Canceled: 'Canceled',
  Pending: 'Pending'
};

exports.ContractAIExtractStatus = exports.$Enums.ContractAIExtractStatus = {
  STARTED: 'STARTED',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
};

exports.ContractAIExtractFieldStatus = exports.$Enums.ContractAIExtractFieldStatus = {
  STARTED: 'STARTED',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
};

exports.LocationClass = exports.$Enums.LocationClass = {
  APlus: 'APlus',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  AMinus: 'AMinus',
  BPlus: 'BPlus',
  BMinus: 'BMinus',
  CPlus: 'CPlus',
  CMinus: 'CMinus',
  DPlus: 'DPlus',
  DMinus: 'DMinus'
};

exports.LocationStatus = exports.$Enums.LocationStatus = {
  Active: 'Active',
  Pending: 'Pending',
  Disposed: 'Disposed'
};

exports.LocationPropertyStage = exports.$Enums.LocationPropertyStage = {
  LeaseUp: 'LeaseUp',
  Stabilized: 'Stabilized',
  Renovation: 'Renovation',
  Other: 'Other'
};

exports.LocationPropertyType = exports.$Enums.LocationPropertyType = {
  ConventionalMultifamily: 'ConventionalMultifamily',
  Affordable: 'Affordable',
  Student: 'Student',
  Senior: 'Senior',
  SelfStorage: 'SelfStorage',
  OfficeCommercial: 'OfficeCommercial',
  BuildToRent: 'BuildToRent',
  SingleFamily: 'SingleFamily',
  Other: 'Other'
};

exports.LocationGroupRoleType = exports.$Enums.LocationGroupRoleType = {
  Viewer: 'Viewer'
};

exports.TaskScheduleStatus = exports.$Enums.TaskScheduleStatus = {
  Upcoming: 'Upcoming',
  ReadyToDo: 'ReadyToDo',
  Overdue: 'Overdue',
  Archived: 'Archived'
};

exports.TaskCompletionStatus = exports.$Enums.TaskCompletionStatus = {
  Incomplete: 'Incomplete',
  Completed: 'Completed',
  Canceled: 'Canceled'
};

exports.TaskLocationDispositionCompletionWith = exports.$Enums.TaskLocationDispositionCompletionWith = {
  Disposed: 'Disposed',
  Keep: 'Keep'
};

exports.IntelligenceNotificationType = exports.$Enums.IntelligenceNotificationType = {
  TaskMessageMention: 'TaskMessageMention',
  TaskMessageOwner: 'TaskMessageOwner',
  TaskScheduleStatusChange: 'TaskScheduleStatusChange',
  TaskCompletionStatusChange: 'TaskCompletionStatusChange',
  TaskDueDateChange: 'TaskDueDateChange',
  ZiplineReadyForReview: 'ZiplineReadyForReview',
  ZiplineReassigned: 'ZiplineReassigned',
  ZiplineCanceled: 'ZiplineCanceled',
  ComplianceProgramCredentialInvitationsSent: 'ComplianceProgramCredentialInvitationsSent',
  PendingUserInvitations: 'PendingUserInvitations'
};

exports.EmojiType = exports.$Enums.EmojiType = {
  Thumbsup: 'Thumbsup',
  Heart: 'Heart',
  Joy: 'Joy',
  WhiteCheckMark: 'WhiteCheckMark',
  Tada: 'Tada'
};

exports.GeneralLedgerImportStandard = exports.$Enums.GeneralLedgerImportStandard = {
  Standard1: 'Standard1',
  Standard2: 'Standard2',
  Standard3: 'Standard3',
  VendorPaidSetup: 'VendorPaidSetup'
};

exports.ExtendWorkflowStatus = exports.$Enums.ExtendWorkflowStatus = {
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  REVIEWED: 'REVIEWED',
  REJECTED: 'REJECTED',
  PROCESSED: 'PROCESSED'
};

exports.LocationNoticeStatus = exports.$Enums.LocationNoticeStatus = {
  InProgress: 'InProgress',
  Saved: 'Saved',
  Sent: 'Sent'
};

exports.LocationNoticeStep = exports.$Enums.LocationNoticeStep = {
  Details: 'Details',
  Recipients: 'Recipients',
  EmailTemplate: 'EmailTemplate'
};

exports.LocationServiceTerminationStep = exports.$Enums.LocationServiceTerminationStep = {
  Details: 'Details',
  SelectServices: 'SelectServices',
  EmailTemplate: 'EmailTemplate'
};

exports.LocationRoleType = exports.$Enums.LocationRoleType = {
  Editor: 'Editor',
  Viewer: 'Viewer'
};

exports.OAuthProvider = exports.$Enums.OAuthProvider = {
  MICROSOFT: 'MICROSOFT'
};

exports.ComplianceProgramCredentialStatus = exports.$Enums.ComplianceProgramCredentialStatus = {
  NotStarted: 'NotStarted',
  Complete: 'Complete',
  Paused: 'Paused',
  InProgress: 'InProgress'
};

exports.ESignWorkflowStatus = exports.$Enums.ESignWorkflowStatus = {
  Active: 'Active',
  Inactive: 'Inactive'
};

exports.ESignWorkflowRunStatus = exports.$Enums.ESignWorkflowRunStatus = {
  Invited: 'Invited',
  Accepted: 'Accepted',
  Signed: 'Signed',
  Rejected: 'Rejected',
  Expired: 'Expired',
  QuestionSubmitted: 'QuestionSubmitted'
};

exports.ESignWorkflowRunEventType = exports.$Enums.ESignWorkflowRunEventType = {
  WorkflowCreated: 'WorkflowCreated',
  FileCreated: 'FileCreated',
  FileUpdated: 'FileUpdated',
  VendorInvited: 'VendorInvited',
  VendorAccepted: 'VendorAccepted',
  VendorSigned: 'VendorSigned',
  VendorRejected: 'VendorRejected',
  VendorReminded: 'VendorReminded',
  VendorInvitedColleague: 'VendorInvitedColleague',
  VendorContactChanged: 'VendorContactChanged',
  VendorAskedQuestion: 'VendorAskedQuestion'
};

exports.ManagerAccountVendorRoleType = exports.$Enums.ManagerAccountVendorRoleType = {
  Manager: 'Manager',
  ContractSigner: 'ContractSigner'
};

exports.LocationVendorRoleType = exports.$Enums.LocationVendorRoleType = {
  Manager: 'Manager',
  ContractSigner: 'ContractSigner'
};

exports.ContractTemplateEventType = exports.$Enums.ContractTemplateEventType = {
  DraftTemplateCreated: 'DraftTemplateCreated',
  DraftTemplateEdited: 'DraftTemplateEdited',
  TemplateActivated: 'TemplateActivated',
  ActiveTemplateEdited: 'ActiveTemplateEdited',
  TemplateArchived: 'TemplateArchived'
};

exports.ContractTemplateStatus = exports.$Enums.ContractTemplateStatus = {
  Active: 'Active',
  Archived: 'Archived',
  Draft: 'Draft',
  Processing: 'Processing'
};

exports.ContractTemplateVariableName = exports.$Enums.ContractTemplateVariableName = {
  vendor_name: 'vendor_name',
  vendor_address: 'vendor_address',
  location_name: 'location_name',
  location_address: 'location_address',
  company_account_name: 'company_account_name',
  company_account_address: 'company_account_address',
  text_field: 'text_field',
  amount: 'amount',
  todays_date: 'todays_date',
  contract_term_length: 'contract_term_length',
  contract_effective_date: 'contract_effective_date',
  initial_term_end_date: 'initial_term_end_date',
  current_term_end_date: 'current_term_end_date',
  termination_notice_period: 'termination_notice_period',
  termination_notice_details: 'termination_notice_details',
  disposition_instructions: 'disposition_instructions',
  entry: 'entry'
};

exports.ContractTemplateVariableAmountFormat = exports.$Enums.ContractTemplateVariableAmountFormat = {
  Number: 'Number',
  Currency: 'Currency',
  Percentage: 'Percentage'
};

exports.ContractEntryStatus = exports.$Enums.ContractEntryStatus = {
  Active: 'Active',
  Archived: 'Archived',
  Draft: 'Draft'
};

exports.ContractTemplateEntryOptionVariableName = exports.$Enums.ContractTemplateEntryOptionVariableName = {
  vendor_name: 'vendor_name',
  vendor_address: 'vendor_address',
  location_name: 'location_name',
  location_address: 'location_address',
  company_account_name: 'company_account_name',
  company_account_address: 'company_account_address',
  text_field: 'text_field',
  amount: 'amount'
};

exports.ContractExecutionType = exports.$Enums.ContractExecutionType = {
  ContractTemplate: 'ContractTemplate',
  Upload: 'Upload'
};

exports.ContractExecutionStatus = exports.$Enums.ContractExecutionStatus = {
  Draft: 'Draft',
  Sending: 'Sending',
  DeliveryFailed: 'DeliveryFailed',
  Sent: 'Sent',
  SignerUpdate: 'SignerUpdate',
  Declined: 'Declined',
  Rejected: 'Rejected',
  VendorSigned: 'VendorSigned',
  LinkExpired: 'LinkExpired',
  Voided: 'Voided',
  Active: 'Active'
};

exports.ContractExecutionRejectionReason = exports.$Enums.ContractExecutionRejectionReason = {
  PricingDiscrepancy: 'PricingDiscrepancy',
  TermsAndConditionsIssue: 'TermsAndConditionsIssue',
  ServiceScopeMismatch: 'ServiceScopeMismatch',
  MissingInformation: 'MissingInformation',
  Other: 'Other'
};

exports.ContractExecutionEventType = exports.$Enums.ContractExecutionEventType = {
  VendorInvited: 'VendorInvited',
  VendorAccepted: 'VendorAccepted',
  VendorSigned: 'VendorSigned',
  VendorDeclined: 'VendorDeclined',
  VendorRequestedSignerUpdate: 'VendorRequestedSignerUpdate',
  DeliveryFailed: 'DeliveryFailed',
  ContractVoided: 'ContractVoided',
  ContractLinkExpired: 'ContractLinkExpired',
  CountersignerDeclined: 'CountersignerDeclined',
  CounterSigned: 'CounterSigned'
};

exports.Prisma.ModelName = {
  Impersonation: 'Impersonation',
  AuditLog: 'AuditLog',
  User: 'User',
  UserCredential: 'UserCredential',
  UserRole: 'UserRole',
  UserInvitationEvent: 'UserInvitationEvent',
  UserInvitation: 'UserInvitation',
  ForgotPasswordToken: 'ForgotPasswordToken',
  EmailVerificationToken: 'EmailVerificationToken',
  OAuthClient: 'OAuthClient',
  OAuthCode: 'OAuthCode',
  OAuthToken: 'OAuthToken',
  Vendor: 'Vendor',
  ProductCategory: 'ProductCategory',
  Product: 'Product',
  ProductAward: 'ProductAward',
  File: 'File',
  ProductFeature: 'ProductFeature',
  ProductPackage: 'ProductPackage',
  Industry: 'Industry',
  GoodForTag: 'GoodForTag',
  VendorIntegration: 'VendorIntegration',
  IntelligenceVendorIntegration: 'IntelligenceVendorIntegration',
  ProductReview: 'ProductReview',
  ProductReviewHelpful: 'ProductReviewHelpful',
  BuyerDomain: 'BuyerDomain',
  ProductSubscription: 'ProductSubscription',
  StripeProduct: 'StripeProduct',
  StripePrice: 'StripePrice',
  BuyerContactRequest: 'BuyerContactRequest',
  Post: 'Post',
  LegalDoc: 'LegalDoc',
  ManagerAccount: 'ManagerAccount',
  ManagerAccountRole: 'ManagerAccountRole',
  ManagerAccountVendor: 'ManagerAccountVendor',
  LocationVendor: 'LocationVendor',
  LocationVendorDocument: 'LocationVendorDocument',
  ManagerAccountVendorContact: 'ManagerAccountVendorContact',
  LocationVendorContact: 'LocationVendorContact',
  ManagerAccountVendorIncident: 'ManagerAccountVendorIncident',
  ManagerAccountVendorDocument: 'ManagerAccountVendorDocument',
  ContractFile: 'ContractFile',
  Contract: 'Contract',
  ContractLineItem: 'ContractLineItem',
  Fee: 'Fee',
  ContractLineItemFee: 'ContractLineItemFee',
  Department: 'Department',
  ContractLocationFile: 'ContractLocationFile',
  ContractLineItemLocation: 'ContractLineItemLocation',
  ContractAIExtract: 'ContractAIExtract',
  ContractAIExtractField: 'ContractAIExtractField',
  Location: 'Location',
  LocationGroup: 'LocationGroup',
  LocationGroupRole: 'LocationGroupRole',
  TaskContractRenewal: 'TaskContractRenewal',
  TaskLocationDisposition: 'TaskLocationDisposition',
  IntelligenceNotification: 'IntelligenceNotification',
  GroupChat: 'GroupChat',
  Message: 'Message',
  MessageFile: 'MessageFile',
  Reaction: 'Reaction',
  GeneralLedgerImport: 'GeneralLedgerImport',
  GeneralLedgerImportRow: 'GeneralLedgerImportRow',
  GeneralLedgerImportStandardConfig: 'GeneralLedgerImportStandardConfig',
  ZiplineExtendWorkflow: 'ZiplineExtendWorkflow',
  ZiplineExtendWebhookEvent: 'ZiplineExtendWebhookEvent',
  RVIAutoExtendWorkflow: 'RVIAutoExtendWorkflow',
  RVIContractExtendWorkflow: 'RVIContractExtendWorkflow',
  RVIContractExtendWebhookEvent: 'RVIContractExtendWebhookEvent',
  RVIAutoExtendWorkflowEvent: 'RVIAutoExtendWorkflowEvent',
  LocationNoticeDisposition: 'LocationNoticeDisposition',
  LocationServiceTerminationNotice: 'LocationServiceTerminationNotice',
  ServiceTerminationContractLineItem: 'ServiceTerminationContractLineItem',
  LocationNoticeDispositionRecipient: 'LocationNoticeDispositionRecipient',
  LocationRole: 'LocationRole',
  UserImpersonation: 'UserImpersonation',
  OAuthCredential: 'OAuthCredential',
  PostAlias: 'PostAlias',
  ComplianceProgramCredentialInvitation: 'ComplianceProgramCredentialInvitation',
  ComplianceProgramCredential: 'ComplianceProgramCredential',
  ComplianceProgramESignWorkflow: 'ComplianceProgramESignWorkflow',
  ESignWorkflow: 'ESignWorkflow',
  ESignWorkflowRun: 'ESignWorkflowRun',
  ESignDocument: 'ESignDocument',
  ESignWorkflowRunEvent: 'ESignWorkflowRunEvent',
  ManagerAccountVendorRole: 'ManagerAccountVendorRole',
  LocationVendorRole: 'LocationVendorRole',
  PmsVendorInfo: 'PmsVendorInfo',
  ComplianceProgram: 'ComplianceProgram',
  ContractTemplateEvent: 'ContractTemplateEvent',
  ContractTemplate: 'ContractTemplate',
  ContractTemplateVersion: 'ContractTemplateVersion',
  ContractTemplateVariable: 'ContractTemplateVariable',
  ContractTemplateContent: 'ContractTemplateContent',
  ContractTemplateEntry: 'ContractTemplateEntry',
  ContractTemplateEntryVersion: 'ContractTemplateEntryVersion',
  ContractTemplateEntryOption: 'ContractTemplateEntryOption',
  ContractTemplateEntryOptionVariable: 'ContractTemplateEntryOptionVariable',
  ContractExecution: 'ContractExecution',
  ContractExecutionVariableValue: 'ContractExecutionVariableValue',
  ContractExecutionEntryOptionVariableValue: 'ContractExecutionEntryOptionVariableValue',
  ContractExecutionSupportingFile: 'ContractExecutionSupportingFile',
  ContractExecutionEvent: 'ContractExecutionEvent',
  ContractExecutionDocument: 'ContractExecutionDocument',
  ContractExecutionLineItem: 'ContractExecutionLineItem',
  ContractExecutionLineItemFee: 'ContractExecutionLineItemFee',
  ContractExecutionLineItemLocation: 'ContractExecutionLineItemLocation'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
